import { render, staticRenderFns } from "./IconStatsSearch.vue?vue&type=template&id=52dd16d1&"
import script from "./IconStatsSearch.vue?vue&type=script&lang=js&"
export * from "./IconStatsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52dd16d1')) {
      api.createRecord('52dd16d1', component.options)
    } else {
      api.reload('52dd16d1', component.options)
    }
    module.hot.accept("./IconStatsSearch.vue?vue&type=template&id=52dd16d1&", function () {
      api.rerender('52dd16d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconStatsSearch.vue"
export default component.exports